/**
 * Avatar color utilities for consistent user/key identification
 */

// Palette of distinct, accessible colors for avatars
const AVATAR_COLORS = [
  '#E53E3E', // red.500
  '#DD6B20', // orange.500
  '#D69E2E', // yellow.500
  '#38A169', // green.500
  '#319795', // teal.500
  '#3182CE', // blue.500
  '#805AD5', // purple.500
  '#D53F8C', // pink.500
  '#00B5D8', // cyan.500
  '#ED8936', // orange.400
]

/**
 * Generate a consistent color from a string (e.g., API key, user ID)
 * Uses a simple hash function to map strings to colors deterministically
 *
 * @param str - The string to generate a color from
 * @returns A hex color string
 */
export function getAvatarColor(str: string | null | undefined): string {
  if (!str) return '#805AD5' // default purple

  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }

  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length] ?? '#805AD5'
}

/**
 * Get initials from a name for avatar display
 *
 * @param name - The name to extract initials from
 * @returns 1-2 character initials
 */
export function getInitials(name: string | null | undefined): string {
  if (!name) return '?'

  const words = name.trim().split(/\s+/)
  if (words.length === 1) {
    return words[0]?.charAt(0).toUpperCase() ?? '?'
  }

  return (
    (words[0]?.charAt(0) ?? '') + (words[words.length - 1]?.charAt(0) ?? '')
  ).toUpperCase()
}
